import { render } from "./GameAboutView.vue?vue&type=template&id=5ced945a"
const script = {}

import exportComponent from "/var/www/rastemo/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__